// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("./utils.res.js");

function TextInputNew(props) {
  var disabled = props.disabled;
  var __inputBoxContainerCss = props.inputBoxContainerCss;
  var __containerClassName = props.containerClassName;
  var __textInputClassName = props.textInputClassName;
  var placeholder = props.placeholder;
  var labelCSS = props.labelCSS;
  var maxLength = props.maxLength;
  var __error = props.error;
  var errorText = props.errorText;
  var errorCSS = props.errorCSS;
  var handleChange = props.handleChange;
  var __inputType = props.inputType;
  var inputType = __inputType !== undefined ? __inputType : "text";
  var error = __error !== undefined ? __error : false;
  var textInputClassName = __textInputClassName !== undefined ? __textInputClassName : "outline-none border border-gray-400 h-10 rounded px-3 py-2 text-sm";
  var containerClassName = __containerClassName !== undefined ? __containerClassName : "flex justify-between items-center";
  var inputBoxContainerCss = __inputBoxContainerCss !== undefined ? __inputBoxContainerCss : "flex flex-col w-3/5";
  var handleValidation = function ($$event) {
    var name_input = Utils$ReactHooksTemplate.formTargetValue($$event);
    var firstChar = name_input[0];
    var check = Belt_Array.getBy([
          "<",
          "!",
          "=",
          "+",
          "-",
          "@",
          ">",
          "?",
          "'",
          "\"",
          "$",
          "#",
          "%",
          "^",
          "*",
          "(",
          ")",
          "/",
          ".",
          "&",
          ",",
          ";",
          "`",
          "~"
        ], (function (x) {
            return firstChar === x;
          }));
    if (check !== undefined) {
      console.log("Invalid Characters!");
      return ;
    } else {
      return Curry._1(handleChange, $$event);
    }
  };
  var maximumLength = maxLength !== undefined ? maxLength : 524288;
  var disabled$p = disabled !== undefined && disabled ? true : false;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: props.label,
                      className: labelCSS !== undefined ? labelCSS : "text-sm font-medium " + Belt_Option.getWithDefault(props.labelClassName, "")
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("input", {
                              className: textInputClassName,
                              disabled: disabled$p,
                              maxLength: maximumLength,
                              placeholder: placeholder !== undefined ? placeholder : "",
                              type: inputType,
                              value: props.value,
                              onChange: handleValidation
                            }),
                        error ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: errorText !== undefined ? errorText : "Error",
                                      className: "float-right"
                                    }),
                                className: errorCSS !== undefined ? errorCSS : "text-red-600 font-sm"
                              }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                      ],
                      className: inputBoxContainerCss
                    })
              ],
              className: containerClassName
            });
}

var make = TextInputNew;

exports.make = make;
/* react/jsx-runtime Not a pure module */
